export default class AnimationsTextLines {
	private paragraph: HTMLElement;
	private width: number;
	private interval: any;

	constructor(element: string) {
		this.paragraph = document.querySelector(element);
		if (this.paragraph) {
			this.detectFontChange(() => {
				this.findLineBreaks();
				this.createLines();
			});
		}
		// NOTE: this does not take into account font loading
	}
	private detectFontChange(callback: Function) {
		let iteration = 0;
		let div = document.createElement('DIV');
		div.classList.add('font-detect');
		div.innerHTML = "TEXT WIDTH";
		this.width = div.offsetWidth;

		document.body.append(div);

		this.interval = window.setInterval(() => {
			if (div.offsetWidth != this.width || iteration == 10) {
				div.remove();
				clearInterval(this.interval);
				callback();
			}
			if (iteration != 10) {
				iteration = iteration + 1;
			}
		}, 100);
	}
	private findLineBreaks = () => {
		this.paragraph.innerHTML = this.paragraph.textContent.split(' ').join('<w></w> ');

		var words = this.paragraph.getElementsByTagName('w');
		var lastTop = 0;
		for (var i = 0, l = words.length; i < l; i++) {
			var newTop = words[i].getBoundingClientRect().top;
			if (newTop != lastTop) {
				if (i - 1 > 0) {
					words[i - 1].classList.add('no');
				}
				lastTop = newTop;
			}
		}
	}
	private createLines = () => {
		let inner = this.paragraph.innerHTML;
		inner = inner.replace(/<w><\/w>/g, '');
		inner = inner.replace(/<w class="no"><\/w>/g, '</span><span class="line">');

		this.paragraph.innerHTML = `<span class="line">${inner}</span>`;
	}
}

